<div class="container">
    <h1>{{ 'Error 404' | translate }}</h1>
    <h3>{{ '¡Página no encontrada!' | translate }}</h3>
</div>
